import Api from "./base/api-base";

export default class permissionsApi {
  list() {
    return Api.get({
      endpoint: Api.endpoint.permissions,
    });
  }

  store (params) {
    return Api.post({
      endpoint: Api.endpoint.permissions,
      params: params
    });
  }

  info (id) {
    return Api.get({
      endpoint: Api.endpoint.permissions,
      id: id,
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.permissions,
      id: id,
      params: params
    });
  }

  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.permissions,
      id: id,
    });
  }
}
